import React, { useEffect, useRef } from 'react';
import type { Message } from '../types';
import { TypingIndicator } from './TypingIndicator';
import '../styles/widget.css';

interface MessageListProps {
  messages: Message[];
  isTyping: boolean;
}

export const MessageList: React.FC<MessageListProps> = ({ messages, isTyping }) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isTyping]);

  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const minutes = Math.floor(diff / 60000);

    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes}m ago`;
    if (date.toDateString() === now.toDateString()) {
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
  };

  return (
    <div className="securedevkit-chat-messages">
      {messages.length === 0 && (
        <div style={{ textAlign: 'center', color: '#6c757d', padding: '40px 20px' }}>
          <p>Start a conversation by sending a message!</p>
        </div>
      )}
      {messages.map((message) => (
        <div
          key={message.id}
          className={`securedevkit-chat-message ${message.role}`}
        >
          <div className="securedevkit-chat-message-content">
            <div>{message.content}</div>
            <div className="securedevkit-chat-message-time">
              {formatTime(message.createdAt)}
            </div>
          </div>
        </div>
      ))}
      {isTyping && <TypingIndicator />}
      <div ref={messagesEndRef} />
    </div>
  );
};

